/**
 * @file index.tsx
 *
 * @fileoverview Renders navigation menu that supports sub menus.
 */
import {
  Root,
  List,
  Item,
  Trigger,
  Content,
} from "@radix-ui/react-navigation-menu";
import ArrowDownIcon from "@jq-icons/ArrowDown";
import FlexItems from "../../../02-atoms/06-layout/03-flex";
import FlexItem from "../../../02-atoms/06-layout/03-flex/02-flex-item";
import styles from "./desktopMenu.module.scss";

export default function NavigationMenu({ children, ...props }) {
  return (
    <Root {...props}>
      <List className={styles.list}>{children}</List>
    </Root>
  );
}

export function NavigationMenuContent({ children }) {
  return <Content className={styles.content}>{children}</Content>;
}

export function NavigationMenuTrigger({ children }) {
  return (
    <Trigger
      className={`
      ${styles.trigger}
      ${styles.menuLink}
    `.trim()}
    >
      <FlexItems gap={2}>
        <FlexItem>{children}</FlexItem>
        <FlexItem>
          <ArrowDownIcon></ArrowDownIcon>
        </FlexItem>
      </FlexItems>
    </Trigger>
  );
}
export { NavigationMenu, Item as NavigationMenuItem };
